/**
 * The way back, from anywhere.
 *
 * Every screen that is not the room now carries it, and so does the table.
 * Before this there were three different ways out depending on where you were
 * standing — a "Back to the Room" link on some pages, a button on the action
 * bar that only appeared in some states, and on one screen nothing at all. A
 * player who wants to go home should not have to work out which page they are
 * on first.
 *
 * The mark rather than a word: it is the room's own, it needs no translating,
 * and at the size a top bar allows it is the only thing that stays legible.
 */

export function HomeLink({ label = 'Home' }: { label?: string }) {
  return (
    <a className="home-link" href="/" title={label} aria-label={label}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M3 11.2 12 4l9 7.2V20a1 1 0 0 1-1 1h-5.5v-6h-5v6H4a1 1 0 0 1-1-1z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
      <span>{label}</span>
    </a>
  );
}
